/* ============
 * Bootstrap File
 * ============
 *
 * Will configure and bootstrap the application
 */


/* ============
 * Vue
 * ============
 *
 * Vue.js is a library for building interactive web interfaces.
 * It provides data-reactive components with a simple and flexible API.
 *
 * http://rc.vuejs.org/guide/
 */
import Vue from 'vue';

Vue.config.debug = process.env.NODE_ENV !== 'production';

const bus = new Vue();

// Bind the event bus to Vue.
Vue.$bus = bus;
Object.defineProperty(Vue.prototype, '$bus', {
  get() {
    return bus;
  },
});


/* ============
 * Axios
 * ============
 *
 * Promise based HTTP client for the browser and node.js.
 * Because Vue Resource has been retired, Axios will now been used
 * to perform AJAX-requests.
 *
 * https://github.com/mzabriskie/axios
 */
import Axios from 'axios';
import authService from './app/services/auth';

Axios.defaults.baseURL = process.env.API_LOCATION;
Axios.defaults.headers.common.Accept = 'application/json';

Axios.interceptors.response.use(
  response => response,
  (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        authService.logout();
        return;
      } else if (error.response.status === 403) {
        if (error && error.response && error.response.data && error.response.data.msg) {
          toastr.error(error.response.data.msg);
          return false;
        }
        return Promise.reject(error.response);
      }
    }
    return Promise.reject(error);
  });

Vue.$http = Axios;


/* ============
 * Vuex Router Sync
 * ============
 *
 * Effortlessly keep vue-Router and vuex store in sync.
 *
 * https://github.com/vuejs/vuex-router-sync/blob/master/README.md
 */
import VuexRouterSync from 'vuex-router-sync';
import store from './app/store';

store.dispatch('checkAuthentication');


/* ============
 * Vue Router
 * ============
 *
 * The official Router for Vue.js. It deeply integrates with Vue.js core
 * to make building Single Page Applications with Vue.js a breeze.
 *
 * http://router.vuejs.org/en/index.html
 */
import VueRouter from 'vue-router';
import routes from './app/routes';

Vue.use(VueRouter);

export const router = new VueRouter({
  routes,
});
router.beforeEach((to, from, next) => {

  if (to.matched.some(m => m.meta.guest) && !to.matched.some(m => m.meta.staticPwdPassed) && !process.env.STATIC_PWD_STATUS) {
    /*
     * If the STATIC_PWD_STATUS disabled user and visits
     * static password page, redirect to login page
     */
    next({
      name: 'login.index',
    });
  } else if (to.matched.some(m => m.meta.guest) && to.matched.some(m => m.meta.staticPwdPassed) && localStorage.getItem("staticPwdPassed") != 'true' && process.env.STATIC_PWD_STATUS) {
    /*
     * If the user is not passed static password and visits
     * login or register page, redirect to static password page
     */
    next({
      name: 'static-pwd.index',
    });
  } else if (to.matched.some(m => m.meta.guest) && to.matched.some(m => m.meta.staticPwdPassed) == false && localStorage.getItem("staticPwdPassed") == 'true') {
    /*
     * If the user is already passed static password and visits
     * static password page, redirect to login page
     */
    next({
      name: 'login.index',
    });
  } else if (to.matched.some(m => m.meta.auth) && !store.state.auth.authenticated) {
    /*
     * If the user is not authenticated and visits
     * a page that requires authentication, redirect to the login page
     */
    next({
      name: 'login.index',
    });
  } else if (to.matched.some(m => m.meta.guest) && store.state.auth.authenticated) {
    /*
     * If the user is authenticated and visits
     * an guest page, redirect to the dashboard page
     */
    next({
      name: 'calendar.index',
    });
  } else if (to.matched.some(m => m.meta.auth) && to.matched.some(m => m.meta.admin) && localStorage.getItem("role_id") != 1 ){
    next({
      name: 'calendar.index',
    });
  } else {

    let bodyClass = '';
    switch (to.name) {
      case 'static-pwd.index':
      case 'login.index':
        bodyClass = 'animsition page-login-v2 layout-full page-dark';
        break;
      case 'register.index':
        bodyClass = 'animsition page-register-v2 layout-full page-dark';
        break;
      case 'payment.permalink':
        bodyClass = 'layout-full';
        break;
      case 'home.index':
        bodyClass = 'animsition dashboard';
        break;
      case 'password.index':
        bodyClass = 'animsition page-forgot-password layout-full page-dark';
        break;
      case 'password.reset':
        bodyClass = 'animsition page-forgot-password layout-full page-dark';
        break;
      case 'form.preview':
        bodyClass = 'preview-body';
        break;
      case 'form.show':
        bodyClass = 'preview-body';
        break;
      case 'account.settings':

        break;
      default:
        bodyClass = '';
        break;
    }

    $('body').attr('class', bodyClass);

    if(window.innerWidth < 768) {
      $('body').attr('class', 'site-menubar-hide');
    }

    next();
  }
});
VuexRouterSync.sync(store, router);

Vue.router = router;


/* ============
 * Vue i18n
 * ============
 *
 * Internationalization plugin of Vue.js
 *
 * https://kazupon.github.io/vue-i18n/
 */
import VueI18n from 'vue-i18n';
import locale from './app/i18n';

Vue.use(VueI18n);

Vue.config.lang = 'fr';

Object.keys(locale).forEach((lang) => {
  Vue.locale(lang, locale[lang]);
});

/* ============
 * Vue Filters
 * ============
 *
 * Global Filters plugin of Vue.js
 *
 */
import filters from './app/filters';

Vue.use(filters);


/* ============
 * jQuery
 * ============
 *
 * Require jQuery
 *
 * http://jquery.com/
 */

import jQuery from 'jquery';

window.$ = window.jQuery = jQuery;
window.webuiPopover = require('webui-popover');
window.jSignature = require('../static/material/global/js/jsignature/libs/jSignature.min.js');

// Material
import '../static/assets/css/main.less';
import '../static/assets/css/invoice.less';
import '../static/assets/css/contract.less';
import '../static/assets/css/payment.less';
import '../static/assets/css/media-queries.less';
import '../static/material/global/css/multi_calendar.css';
import '../static/material/global/css/market_analysis.less';
import '../static/assets/css/permalink.less';
import '../static/assets/css/scheduler.less';

// global plugins

import '../static/material/global/vendor/bootstrap-sweetalert/sweetalert.min';
import '../static/material/global/vendor/bootstrap-sweetalert/sweetalert.css';

export default {
  router,
};



// WEBPACK FOOTER //
// ./src/bootstrap.js